module.exports = __webpack_public_path__ + "static/media/youtube-play-icone.8aa01068.png";